import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { history } from 'flow/configure-store';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import { createSession } from 'flow/actions/chat-actions';
import Loading from 'flow/components/ui-components/Loading';

/**
 * This component acts as a loading layer for opening
 * chat sessions with only the chatUserKey available.
 * This will mount a loading spinner while fetching relevant
 * data to be able to open the one-on-one chat session.
 *
 * Since the userToSession map only gets populated as sessions
 * are created, it is very likely that the desired one-on-one
 * chat session exists in the list, thus needing to use
 * createSession(...).
 */

const RedirectChatSession = (props) => {
    const {
        chatUserKey,
        userToSession,
        createChatSession,
        redirectToChatSession,
    } = props;

    useEffect(() => {
        const chatSessionKey = userToSession.get(chatUserKey);
        if (chatSessionKey) {
            redirectToChatSession(chatSessionKey);
        } else {
            createChatSession(chatUserKey);
        }
    }, [chatUserKey, userToSession, redirectToChatSession, createChatSession]);

    return <Loading />;
};

RedirectChatSession.propTypes = {
    chatUserKey: PropTypes.string.isRequired,
    userToSession: PropTypes.instanceOf(Map).isRequired,
    createChatSession: PropTypes.func.isRequired,
    redirectToChatSession: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    const { chats } = state;
    const {
        match: {
            params: { chatUserKey },
        },
    } = ownProps;

    const userToSession = chats.get('userToSession');

    return { userToSession, chatUserKey };
};

const mapDispatchToProps = (dispatch) => ({
    createChatSession: (chatUserKey) => dispatch(createSession(chatUserKey)),
    redirectToChatSession: (chatSessionKey) =>
        history.replace(
            generatePath(routes['messages.id'], { id: chatSessionKey }),
        ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RedirectChatSession);
